export default __webpack_public_path__ + "static/media/Traveling_status.ffb0f816.svg";